import cookie from "modules/cookie";

import { replaceHiddenInputValues } from 'modules/replaceHiddenInputValues';
import { loadFriendlyCaptcha, getSDK } from 'modules/FriendlyCaptchaLoader';

(function (w, d) {
    if (d.querySelectorAll(".js-click-dimensions-block").length < 1) return;

    const elementById = d.getElementById.bind(d);

    function getUtmTagsFromUrlOrCookie() {
        const utmParams = decodeURIComponent(window.location.search)
            .substr(1)
            .split("&")
            .filter((p) => p.indexOf("utm_") > -1);

        if (utmParams.length > 0) {
            return utmParams.map((param) => param.split("="));
        }

        const utmCookie = cookie.getCookie("sec_utm");

        if (utmCookie.length > 0) {
            return utmCookie.split("&").map((param) => param.split("="));
        }

        return utmParams;
    }

    const utmParams = getUtmTagsFromUrlOrCookie();

    function pushPostValues(postValues, options) {
        if (window.DY) {
            pushValueToKey(options.geoLocationFieldName, window.DY.geoCity, postValues);
        }

        if (window.ga) {
            const clientId = window.ga.getAll()[0].get("clientId");
            if (clientId) {
                pushValueToKey(options.gaCidFieldName, clientId, postValues);
            }
        }

        pushValueToKey(options.sentFromURLFieldName, location.href, postValues);
    }

    function pushValueToKey(key, value, postValues) {
        const values = postValues[key] || [];
        values.push(value);
        postValues[key] = values;
    }

    const defaultOptions = {
        invalidEmailText: "Please enter a valid email",
        invalidPhoneText: "Please enter a valid phone number",
        invalidMarketingConsent: "Please indicate your marketing preference to continue",
        missingEmailAndPhoneText: "Either phone or email must be entered",
        sendFailText: "Something went wrong, please try again later",
        cookieFail:
            "To be able to send this form you have to allow the cookie '_grecaptcha', we use this to prevent spam.",
        gaCidFieldName: "ga_cid",
        geoLocationFieldName: "ALL_Geo_city",
        sentFromURLFieldName: "sent_from_url",
    };

    function cleanObject(obj) {
        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });
    }

    function ClickDimensionsForm(options) {
        cleanObject(options);

        this.options = Object.assign({}, defaultOptions, options);
        this.container = elementById(options.blockName);
        this.sendSuccess = this.container.getElementsByClassName(
            "click-dimensions-block-send-success"
        )[0];

        this.form = elementById(options.formId);
        this.nameInput = elementById(`name-${options.formId}`);
        this.firstNameInput = elementById(`firstname-${options.formId}`);
        this.lastNameInput = elementById(`lastname-${options.formId}`);
        this.emailInput = elementById(`email-${options.formId}`);
        this.phoneInput = elementById(`phone-${options.formId}`);
        this.consentInput = elementById(`consent-${options.formId}`);
        this.sendButton = elementById(`send-${options.formId}`);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleGreCaptchaReady = this.handleGreCaptchaReady.bind(this);
        this.handleReceiveCaptchaToken = this.handleReceiveCaptchaToken.bind(this);

        this.nameInput.addEventListener("change", this.handleNameChange);
        this.form.addEventListener("submit", this.handleSubmit);
        this.missingCookie = false;
        this.solution = "";

        if (options.siteKey) {
            // This element should contain the `frc-captcha` class for correct styling
            const element = elementById("frc-captcha-widget");
            if (element) {
                // Lazy load Friendly Captcha SDK
                loadFriendlyCaptcha().then(() => {
                    const sdk = getSDK();
                    if (!sdk) {
                        console.error("Friendly Captcha SDK not available after load");
                        return;
                    }
                    const widget = sdk.createWidget({
                        element: element,
                        sitekey: options.siteKey,
                        startMode: "focus",
                        language: options.language,
                    });

                    // V2 uses event listeners instead of callbacks
                    widget.addEventListener("frc:widget.complete", (event) => {
                        this.solution = event.detail.response;
                    });

                    widget.addEventListener("frc:widget.error", () => {
                        // Error is already logged by the SDK
                    });
                }).catch((error) => {
                    console.error("Failed to initialize Friendly Captcha:", error);
                });
            }
        }
    }

    ClickDimensionsForm.prototype = {
        handleNameChange(e) {
            const names = e.target.value.split(" ");
            this.firstNameInput.value = names[0];
            names.shift();
            this.lastNameInput.value = names.join(" ");
        },
        handleSubmit(e) {
            if (!this.validate().valid) {
                e.preventDefault();
                return false;
            }

            if (this.emailInput.value.length === 0) {
                const sanitizedPhone = this.phoneInput.value.replace(/\s+/g, '');
                this.emailInput.value = sanitizedPhone + "@" + d.location.hostname;
            }

            this.nameInput.setAttribute("disabled", "disabled");

            e.preventDefault();

            this.handleReceiveCaptchaToken(
                this.options.siteKey ? this.solution : ""
            );

            return false;
        },
        showError(input, message) {
            // For checkboxes, go up TWO levels; for text inputs, go up ONE level
            const formField = input.type === 'checkbox' ? input.parentElement.parentElement : input.parentElement;
            formField.classList.add("ValidationFail");

            const error = formField.querySelector(".Form__Element__ValidationError");

            if (error) {
                if (this.missingCookie) {
                    error.innerHTML = message ? message.replace(/%.*%/, `<a id="ot-sdk-btn" class="ot-sdk-show-settings">${message.split("%")[1]}</a>`) : "";
                } else {
                    error.textContent = message || "";
                }

                error.classList.add("validation-error");
                error.classList.remove("hide-error");
            }
        },
        hideError(input) {
            // For checkboxes, go up TWO levels; for text inputs, go up ONE level
            const formField = input.type === 'checkbox' ? input.parentElement.parentElement : input.parentElement;
            formField.classList.remove("ValidationFail");

            const error = formField.querySelector(".Form__Element__ValidationError");
            if (error) {
                error.classList.remove("validation-error");
                error.classList.add("hide-error");
            }
        },
        handleGreCaptchaReady() {
            grecaptcha
                .execute(this.options.siteKey, { action: "submit" })
                .then(this.handleReceiveCaptchaToken);
        },
        handleReceiveCaptchaToken(token) {
            this.sendButton.setAttribute("disabled", "disabled");
            this.postForm(token)
                .then((res) => {
                    if (!res.ok) return;
                    res.json().then((d) => {
                        if (d.success) {
                            this.form.classList.add("post-success");

                            const success = this.sendSuccess;
                            success.classList.add("visible");
                        } else {
                            this.showError(this.sendButton, this.options.sendFailText);
                        }
                    });
                })
                .catch(() => {
                    this.showError(this.sendButton, this.options.sendFailText);
                })
                .finally(() => {
                    this.sendButton.removeAttribute("disabled");
                });
        },
        postForm(token) {
            const formData = new FormData(this.form);
            formData.set("token", token);
            formData.set("contentReference", this.options.id);
            formData.set("sent_from_form", "on-page-form");
            formData.set("sent_from_url", location.href);

            utmParams.forEach(([key, value]) => {
                formData.set(key, value);
            });

            const postValues = {};
            pushPostValues(postValues, this.options);

            // Update form data with the grouped values
            Object.keys(postValues).forEach((key) => {
                formData.set(key, postValues[key].join("\n"));
            });

            // Get the antiforgery token
            const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]');
            if (!tokenInput) {
                console.error('Antiforgery token not found');
                this.showError(this.sendButton, 'Security token missing. Please refresh the page.');
                return Promise.reject('Missing antiforgery token');
            }
            const antiforgeryToken = tokenInput.value;

            return fetch('/api/clickdimensions/send', {
                method: 'POST',
                headers: {
                    'X-XSRF-TOKEN': antiforgeryToken,
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: [...formData.entries()]
                    .map(([key, value]) =>
                        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
                    )
                    .join('&')
            });
        },
        validate() {
            if (this.missingCookie) return { valid: false };

            let valid = true;
            const email = this.emailInput.value;
            const phone = this.phoneInput.value;

            if (email.length > 0 && !this.emailValid(email)) {
                valid = false;
                this.showError(this.emailInput, this.options.invalidEmailText);
            } else {
                this.hideError(this.emailInput);
            }

            if (phone.length < 5) {
                valid = false;
                this.showError(this.phoneInput, this.options.invalidPhoneText);
            } else {
                this.hideError(this.phoneInput);
            }

            // Validate marketing consent if checkbox exists
            if (this.consentInput && !this.consentInput.checked) {
                valid = false;
                this.showError(this.consentInput, this.options.invalidMarketingConsent);
            } else if (this.consentInput) {
                this.hideError(this.consentInput);
            }

            return { valid };
        },
        phoneValid(phone) {
            return phone.length > 4;
        },
        emailValid(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    };

    const clickDimensionsBlock = {
        forms: [],
        init: function () {
            const cdForms = w.cdForms || [];
            replaceHiddenInputValues();
            for (let i = 0, len = cdForms.length; i < len; i++) {
                const options = cdForms[i];
                this.forms.push(new ClickDimensionsForm(options));
            }
        },
        destroy: function () {
            this.forms = [];
        },
    };

    clickDimensionsBlock.init();
})(window, document);
